"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonFavorite = void 0;
var react_1 = __importDefault(require("react"));
var ButtonFavorite_module_scss_1 = __importDefault(require("./ButtonFavorite.module.scss"));
var Svg_1 = require("../svg/Svg");
var useFavorite_1 = require("../../hook/useFavorite");
var ButtonFavorite = function (_a) {
    var car = _a.car;
    var _b = (0, useFavorite_1.useFavorite)(car), isFavorite = _b.isFavorite, removeFavorites = _b.removeFavorites, addFavorites = _b.addFavorites;
    var handler = function () {
        if (isFavorite) {
            removeFavorites();
        }
        else {
            addFavorites();
        }
    };
    return (react_1.default.createElement("button", { className: ButtonFavorite_module_scss_1.default.button_favorite, type: "button", onClick: handler, "aria-label": "Add to favorites" },
        react_1.default.createElement(Svg_1.Heart, { customClass: "".concat(isFavorite ? ButtonFavorite_module_scss_1.default.heart_active : '') })));
};
exports.ButtonFavorite = ButtonFavorite;
